import type { CapitalGlobalProposalResumePremiumData } from '@/features/proposals/components/capital-global/utils/map-proposal-to-resume-premium.util';
import { Text } from '@noorden-insurtech/alba-design-system';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { useState } from 'react';

type Props = {
  data: CapitalGlobalProposalResumePremiumData;
};

export function CapitalGlobalProposalResumePremiumSection({ data }: Props) {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className='flex w-full justify-center'>
      <div className='relative flex w-full max-w-[939px] flex-col items-center rounded-2xl bg-linear-to-br from-[#2C285F] to-[#18163D] px-6 py-6 text-center'>
        <button
          type='button'
          onClick={() => setCollapsed(!collapsed)}
          className='absolute top-0 right-0 cursor-pointer border-none bg-transparent px-6 py-4'
          aria-expanded={!collapsed}
        >
          {collapsed ? (
            <ChevronDown className='size-6 text-alba-white-500' />
          ) : (
            <ChevronUp className='size-6 text-alba-white-500' />
          )}
        </button>

        <Text className='mb-2 text-sm text-alba-white-500'>Prêmio Total</Text>
        <Text className='text-3xl font-bold leading-[44px] text-alba-white-500'>
          {data.totalPremium}
        </Text>

        <div className='mt-4 grid w-full grid-cols-2 gap-x-2 gap-y-4 lg:grid-cols-4'>
          <div className='flex flex-col items-start gap-y-0 text-left'>
            <Text className='text-xs text-alba-white-500'>Prêmio Líquido</Text>
            <Text className='text-sm font-bold text-alba-white-500'>
              {data.liquidPremium}
            </Text>
          </div>
          <div className='flex flex-col items-start gap-y-0 text-left'>
            <Text className='text-xs text-alba-white-500'>IOF</Text>
            <Text className='text-sm font-bold text-alba-white-500'>
              {data.iof}
            </Text>
          </div>
          <div className='flex flex-col items-start gap-y-0 text-left'>
            <Text className='text-xs text-alba-white-500'>
              Periodicidade de pagamento
            </Text>
            <Text className='text-sm font-bold text-alba-white-500'>
              {data.paymentPeriodicity}
            </Text>
          </div>
          <div className='flex flex-col items-start gap-y-0 text-left'>
            <Text className='text-xs text-alba-white-500'>
              Forma de pagamento
            </Text>
            <Text className='text-sm font-bold text-alba-white-500'>
              {data.paymentMethod}
            </Text>
          </div>
        </div>

        {!collapsed && (
          <>
            <div className='mt-4 w-full border-t border-[#9FA4A6] pt-4' />
            <div className='grid w-full grid-cols-2 gap-x-2 gap-y-4 lg:grid-cols-4'>
              <div className='flex flex-col items-start gap-y-0 text-left'>
                <Text className='text-xs text-alba-white-500'>Produto</Text>
                <Text className='text-sm font-bold text-alba-white-500'>
                  {data.product}
                </Text>
              </div>
              <div className='flex flex-col items-start gap-y-0 text-left'>
                <Text className='text-xs text-alba-white-500'>
                  Número da Proposta
                </Text>
                <Text className='text-sm font-bold text-alba-white-500'>
                  {data.proposalNumber}
                </Text>
              </div>
              <div className='flex flex-col items-start gap-y-0 text-left'>
                <Text className='text-xs text-alba-white-500'>
                  Dia de vencimento:
                </Text>
                <Text className='text-sm font-bold text-alba-white-500'>
                  {data.dueDay}
                </Text>
              </div>
              <div className='flex flex-col items-start gap-y-0 text-left'>
                <Text className='text-xs text-alba-white-500'>Status</Text>
                <Text className='text-sm font-bold text-alba-white-500'>
                  {data.status}
                </Text>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
